import { BehaviorSubject, of, throwError } from 'rxjs';
import { environment } from 'environments/environment';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { mapResponseWithData } from '../helpers/';
import { Producer } from '../models/producer.model';
import { AuthGuardService } from './auth-guard.service';
import * as i0 from "@angular/core";
import * as i1 from "./auth-guard.service";
import * as i2 from "@angular/common/http";
var ProducerService = /** @class */ (function () {
    function ProducerService(authGuardService, http) {
        this.authGuardService = authGuardService;
        this.http = http;
        this.currentSubject = new BehaviorSubject(new Producer());
        this.currentProducer = this.currentSubject.asObservable();
    }
    Object.defineProperty(ProducerService.prototype, "currentProducerValue", {
        get: function () {
            return this.currentSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    ProducerService.prototype.persistData = function (newData) {
        this.currentSubject.next(newData);
    };
    ProducerService.prototype.getByUserID = function (user) {
        var _this = this;
        if (user && (!this.producers || user.UserId !== this.userId)) {
            return this.getProducersInfoByCurrentUser()
                .pipe(map(function (producers) {
                if (producers) {
                    _this.userId = user.UserId;
                    _this.producers = producers;
                    var expected_1 = new Set();
                    _this.organizers = producers.map(function (producer) { return producer.organizer; })
                        .filter(function (item) { return !expected_1.has(JSON.stringify(item)) ? expected_1.add(JSON.stringify(item)) : false; });
                    return producers;
                }
                else {
                    return [];
                }
            }), catchError(function (error) { return throwError(error); }));
        }
        else {
            return of(this.producers);
        }
    };
    ProducerService.prototype.getFullData = function (branchOffice, producerNumber, organizerNumber) {
        return this.http.get(environment.server.api.contactManager + '/api/Producers' +
            '/branchOffice/' + branchOffice +
            '/producerNumber/' + producerNumber +
            '/organizerNumber/' + organizerNumber).pipe(map(mapResponseWithData));
    };
    ProducerService.prototype.getFormattedProducerCode = function (producer) {
        var producerNumber;
        var branchOfficeNumber;
        if (typeof (producer) === 'object') {
            producerNumber = String(producer.number).padStart(6, '0');
            branchOfficeNumber = String(producer.branchOffice).padStart(2, '0');
        }
        else if (typeof (producer) === 'string') {
            branchOfficeNumber = String(producer.split('-')[0]).padStart(2, '0');
            producerNumber = String(producer.split('-')[1]).padStart(6, '0');
        }
        return branchOfficeNumber + "-" + producerNumber;
    };
    ProducerService.prototype.getUsersByProducerCode = function (userCode) {
        return this.http.get(environment.server.api.auth + '/api/user?producerCode=' + userCode);
    };
    ProducerService.prototype.getProducerByProducerCode = function (producerCode) {
        var producerCodeParts = producerCode.split('-');
        var branchOffice = Number(producerCodeParts[0]);
        var producerNumber = Number(producerCodeParts[1]);
        return this.getByUserID(this.authGuardService.user).pipe(map(function (producers) {
            return producers.find(function (p) { return p.number === producerNumber && p.branchOffice === branchOffice; });
        }));
    };
    ProducerService.prototype.getProducerCodes = function () {
        var _this = this;
        return this.getByUserID(this.authGuardService.user).pipe(map(function (producers) {
            return producers ? producers.map(function (producer) { return _this.getFormattedProducerCode(producer); }) : [];
        }));
    };
    ProducerService.prototype.getMicrositeProducerInformation = function (cuit) {
        return this.http.get(environment.server.api.marketing + "/Microsites/MyData/" + cuit);
    };
    ProducerService.prototype.updateQuoteStatus = function (producerCodes) {
        var body = {
            producerCodes: producerCodes
        };
        return this.http.put(environment.server.api.marketing + "/Quote/UpdateQuoteStatus", body);
    };
    ProducerService.prototype.getProducersInfoByCurrentUser = function (withCommissionValidation) {
        if (withCommissionValidation === void 0) { withCommissionValidation = false; }
        return this.http.get(environment.server.api.portalpas + "/Producer?withCommissionValidation=" + withCommissionValidation)
            .pipe(map(function (producers) {
            producers.forEach(function (producer) {
                var producerCodeParts = producer.code.split('-');
                producer.branchOffice = +producerCodeParts[0];
                producer.number = +producerCodeParts[1];
                var organizerCodeParts = producer.organizer.code.split('-');
                producer.organizerNumber = +organizerCodeParts[1];
                producer.organizer.branchOffice = +organizerCodeParts[0];
                producer.organizer.number = +organizerCodeParts[1];
            });
            return producers.sort(function (a, b) { return a.number < b.number ? -1 : 1; });
        }));
    };
    ProducerService.prototype.producerByProducerCode = function (producerCode) {
        return this.http.get(environment.server.api.portalpasProxy + "/policycenter-producer/api/v3.1/Producers/" + producerCode);
    };
    ProducerService.prototype.getLoggedInProducerWithCuit = function (cuitWithOutLastDigit) {
        var searchByCuit = this.producers.find(function (producer) { return producer.cuit.replace(/[-]*/g, '').startsWith(cuitWithOutLastDigit); })
            || this.organizers.find(function (organizer) { return organizer.cuit.replace(/[-]*/g, '').startsWith(cuitWithOutLastDigit); });
        var searchByNumber = this.producers.find(function (producer) { return cuitWithOutLastDigit.endsWith(producer.number.toString()); })
            || this.organizers.find(function (producer) { return cuitWithOutLastDigit.endsWith(producer.number.toString()); });
        return searchByCuit ? searchByCuit : searchByNumber;
    };
    ProducerService.prototype.getPersonsByDocNumberV3 = function (doumentId, officialIdTypeCode) {
        var baseUrl = environment.server.api.contactManager;
        return this.http.get(baseUrl + "/api/Contacts/SearchByTaxId?taxId=" + doumentId + "&officialIdTypeCode=" + officialIdTypeCode);
    };
    ProducerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProducerService_Factory() { return new ProducerService(i0.ɵɵinject(i1.AuthGuardService), i0.ɵɵinject(i2.HttpClient)); }, token: ProducerService, providedIn: "root" });
    return ProducerService;
}());
export { ProducerService };
